/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useNavigate, useLocation } from "react-router-dom";
import { empty, errorResponse, prepareResponseData } from "../../Utilities/utils";
import { AuthContext } from "../Root/ProtectedRoute";

// css
import "../students/Students.css";

// api
import activitiesApi from "../../api/Activities";

//components
import MainHeader from "../../components/headers/mainHeader/MainHeader";
import { Toast } from "primereact/toast";
import FullPageLoader from "../../components/loader/FullPageLoader";
import TableLoading from "../../components/skeleton/TableLoading";
import { FaPlus } from "react-icons/fa";
import ActivitiesWrapper from "../../components/appWrapper/ActivitiesWrapper";
import ActivitiesTable from "../../components/tables/primeTable/activities/ActivitiesTable";

const ListActivities = ({ ...props }) => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  //ref
  const toastTR = useRef(null);
  // states
  const [activities, setActivities] = useState([]);
  const [activityModalVisibility, setActivityModalVisibility] = useState(false);
  const [selectedActivityDetail, setSelectedActivityDetail] =
    useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isActionLoading, setIsActionLoading] = useState(false);
  const [modalType, setModalType] = useState("update");

  useEffect(() => {
    // fetch activity
    try {
      getActivities();

      if (!empty(location) && !empty(location.state)) {
        const paramState = !empty(location.state) ? location.state : {};
        let activityAdded = !empty(paramState.activityAdded)
          ? paramState.activityAdded
          : false;
        let activityUpdated = !empty(paramState.activityUpdated)
          ? paramState.activityUpdated
          : false;
        if (
          activityAdded === true ||
          activityUpdated === true 
        ) {
          const actionType = activityAdded
            ? "added"
            : activityUpdated
            ? "updated"
            : "";
          paramState.activityAdded = false;
          paramState.activityUpdated = false;
          responseDialog(
            "success",
            "Success",
            `Activity ${actionType} successfully!`
          );
          if (!empty(location) && !empty(location.state)) {
            navigate(null, {
              replace: true,
              state: {
                activityAdded: false,
                activityUpdated: false,
              },
            });
          }
        }
      }
    } catch (error) {
      responseDialog(
        "error",
        "Something went wrong",
        "Failed to load activities. Please try again later."
      );
    }
  }, []);

  // function to get all activities
  const getActivities = async () => {
    try {
      if (!isLoading) setIsLoading(true);
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await activitiesApi.getActivities(schoolId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return setActivities([]);
      } else {
        setActivities(response_data.response);
      }
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  //alert functions
  const responseDialog = (severity = null, summary = null, detail = null) => {
    toastTR?.current?.show({
      severity,
      summary,
      detail,
      life: 8000,
    });
  };

  // delete activity
  const deleteActivity = async () => {
    try {
      if (activityModalVisibility) setActivityModalVisibility(false);
      if (!isActionLoading) setIsActionLoading(true);
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const activityId =
        !empty(selectedActivityDetail) &&
        !empty(selectedActivityDetail._id)
          ? selectedActivityDetail._id
          : "";
      const response = await activitiesApi.deleteActivity(schoolId, activityId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        const error_response =
          !empty(response_data) && !empty(response_data.response)
            ? response_data.response
            : "Failed to delete activity";
        return responseDialog("error", "Something went wrong", error_response);
      }

      responseDialog(
        "success",
        "Success",
        `Activity, ${
          !empty(selectedActivityDetail.title)
            ? selectedActivityDetail.title
            : ""
        }, was deleted successfully!`
      );
      return getActivities();
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsActionLoading(false);
    }
  };

  //function to hide confirm modal
  const hideActivityModal = () => {
    setActivityModalVisibility(false);
  };

  //go to update activity page
  const gotToUpdateActivities = (data) => {
    const activityId = !empty(data) && !empty(data._id) ? data._id : "";
    navigate(`/activity/${activityId}/update`);
  };

  // delete activity
  const showDeleteActivitiesModal = (data) => {
    setModalType("delete");
    setSelectedActivityDetail(data);
    setActivityModalVisibility(true);
  };

  const activityModalFooter = (
    <div
      style={{
        marginTop: 20,
      }}
    >
      <Button
        label="No"
        icon="pi pi-times"
        style={{
          backgroundColor: "transparent",
          color: "#e65061",
          borderColor: "#e65061",
          borderWidth: 1,
        }}
        onClick={hideActivityModal}
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        style={{
          backgroundColor: "transparent",
          color: "#389d17",
          borderColor: "#389d17",
          borderWidth: 1,
        }}
        onClick={() => deleteActivity()
        }
      />
    </div>
  );

  return (
    <>
      <ActivitiesWrapper {...props}>
        <main>
          <div className="tableCard">
            {/*  header start */}
            <MainHeader
              button
              buttonText="Add Activity"
              link="/activity/add"
              title="Activities"
              icon={<FaPlus />}
              iconMarginRight={5}
            />
            {/* end of header */}

            {/* table start */}
            {!isLoading ? (
              <ActivitiesTable
                activities={activities}
                goToUpdateActivitiesScreen={gotToUpdateActivities}
                goToDeleteActivitiesScreen={showDeleteActivitiesModal}
              />
            ) : (
              <TableLoading rows={20} cols={3} header={false} />
            )}
            {/* table end  */}
          </div>
        </main>
        {isActionLoading && <FullPageLoader visible={isActionLoading} />}
      </ActivitiesWrapper>

      <Dialog
        visible={activityModalVisibility}
        style={{ width: "32rem", zIndex: 999999 }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header="Confirm"
        modal
        footer={activityModalFooter}
        onHide={hideActivityModal}
      >
        <div
          className="confirmation-content"
          style={{ marginTop: 20, display: "flex", alignItems: "center" }}
        >
          <i
            className="pi pi-exclamation-triangle mr-3"
            style={{ fontSize: "2rem", marginRight: 15, color: "#e65061" }}
          />
          {
            <span>
              Are you sure you want to{" "}
              {modalType === "update" ? (
                !empty(selectedActivityDetail) &&
                !empty(selectedActivityDetail.active) &&
                selectedActivityDetail.active ? (
                  <span style={{ color: "red" }}>
                    <strong>disable</strong>
                  </span>
                ) : (
                  <span style={{ color: "green" }}>
                    <strong>enable</strong>
                  </span>
                )
              ) : (
                <span style={{ color: "red" }}>
                  <strong>delete</strong>
                </span>
              )}{" "}
              the selected activity -{" "}
              <strong>
                {!empty(selectedActivityDetail) &&
                !empty(selectedActivityDetail.title)
                  ? selectedActivityDetail.title
                  : ""}
              </strong>
              {selectedActivityDetail && (
                <b>
                  {!empty(selectedActivityDetail.name)
                    ? selectedActivityDetail.name
                    : ""}
                </b>
              )}
              ?
            </span>
          }
        </div>
      </Dialog>
      <Toast ref={toastTR} style={{ zIndex: 99999 }} position="bottom-left" />
    </>
  );
};

export default ListActivities;
